import { styled } from '@mui/system';
import { Typography, Box, Grid2 } from '@mui/material';

export const TypographyStyledHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.primaryDark,
  fontSize: '1.625rem',
  width: '100%',
  textAlign: 'center',
  fontWeight: 450,
  paddingTop: '1.25rem'
}));

export const InputBoxStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  borderRadius: '0.9375rem',
  border: `0.0625rem solid ${theme.palette.dividerBorder}`
}));

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  fontWeight: 450,
  color: theme.palette.primaryDark,
  fontFamily: 'BGBold',
  padding: '1.25rem'
}));

export const BoxStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
});

export const GridStyled = styled(Grid2)({
  marginTop: '1.875rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '500px',
  minHeight: '117px',
  background: 'rgba(91, 194, 231, 0.5)'
});

export const BMRSection = styled(Grid2)(({ theme }) => ({
  background: theme.palette.common.white,
  margin: '1.875rem',
  borderRadius: '0.9375rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'row',
  width: '100%',
  height: '57px',
  padding: '0.9375rem'
}));

export const SubInfoStyled = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontSize: '1rem',
  lineHeight: '1.25rem',
  fontWeight: 400,
  fontFamily: 'Calibri',
  color: theme.palette.primaryDark
}));

export const BMRTitle = styled(Typography)(({ theme }) => ({
  width: '100%',
  fontWeight: 450,
  color: theme.palette.primaryDark,
  fontFamily: 'BGBold'
}));

export const BMRValue = styled(Typography)(({ theme }) => ({
  fontSize: '1.875rem',
  fontWeight: 700,
  lineHeight: '35px',
  fontFamily: 'Calibri',
  color: theme.palette.lightBlue
}));
